import React, { useState, useEffect } from "react";
import axios from "axios";
import imgCheck from "./images/check.svg";
import imgUnCheck from "./images/uncheck.svg";
import { Form, Button, Alert, Modal } from "react-bootstrap";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getCountryCodeOnce } from "./js/functions/geoCountry";

// ...



import {
  PrivacyPolicyData,
  TermsOfUseData} from './Data.jsx'

const PrivacyPolicyModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered size="lg" aria-labelledby="privacyPolicyTitle">
    <Modal.Header closeButton>
      <Modal.Title id="privacyPolicyTitle">Политика конфиденциальности</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {PrivacyPolicyData}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>Закрыть</Button>
    </Modal.Footer>
  </Modal>
);

const TermsModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered size="lg" aria-labelledby="termsTitle">
    <Modal.Header closeButton>
      <Modal.Title id="termsTitle">Пользовательское соглашение</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {TermsOfUseData}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>Закрыть</Button>
    </Modal.Footer>
  </Modal>
);

const LeadForm = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [userMess, setUserMess] = useState(false);
  const [resStatus, setResStatus] = useState(false);

  const [validPhoneImg, setValidPhoneImg] = useState(null);
  const [validEmailImg, setValidEmailImg] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [countryCode, setCountryCode] = useState(undefined);

  // NEW: модалки
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => {
    let mounted = true;

    getCountryCodeOnce().then((code) => {
      if (mounted && code) setCountryCode(code);
    });

    return () => {
      mounted = false;
    };
  }, []);

  const keyUpHandler = () => {
    if (!phone) {
      setValidPhoneImg(null);
      return;
    }
    isValidPhoneNumber(phone) ? setValidPhoneImg(imgCheck) : setValidPhoneImg(imgUnCheck);
    onKeyPressHandler();
  };

  const validateEmail = (email) => {
    const regexp =
      /^([\da-z]){1}([\da-z-.+]){1,19}(@){1}([\da-z.!$%&'*+/=?^_-]{1,14})(\.){1}([a-z]{1,5})$/i;
    return regexp.test(email);
  };

  const keyUpEmailHandler = () => {
    if (!email) {
      setValidEmailImg(null);
      return;
    }
    validateEmail(email) ? setValidEmailImg(imgCheck) : setValidEmailImg(imgUnCheck);
    onKeyPressHandler();
  };

  const [typingTimer, setTypingTimer] = useState(null);
  const doneTypingHandler = () => {
    const data = { name, phone, email, message };
    fetch('/log.php', {
      method: 'post',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  };
  const onKeyPressHandler = () => {
    if (typingTimer) clearTimeout(typingTimer);
    setTypingTimer(setTimeout(doneTypingHandler, 3000));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!phone || !name || !message) {
      setResStatus("danger");
      setUserMess("Пожалуйста, проверьте введённые данные и повторите попытку");
      return;
    }

    if (isValidPhoneNumber(phone) || validateEmail(email)) {
      const data = { name, phone, email, message };
      setIsSubmitting(true);

      fetch("/contact.php", {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((response) => {
          setIsSubmitting(false);

          if (response.status === "success") {
            setName("");
            setPhone("");
            setMessage("");
            window.dataLayer?.push({
              event: "form_submission_success",
              formId: "contactForm",
            });
          }

          if (response.status === "success" || response.status === "danger") {
            setResStatus(response.status);
            setValidPhoneImg(null);
            setUserMess(response.message);
          }
        });
    } else {
      setResStatus("danger");
      setUserMess("Некорректно указан номер телефона или e-mail!");
    }
  };

  const nameChangeHandler = (val) => { setName(val.target.value); onKeyPressHandler(); };
  const emailChangeHandler = (val) => { setEmail(val.target.value); onKeyPressHandler(); };

  return (
    <>
      {/* Модальные окна */}
      <PrivacyPolicyModal show={showPrivacy} onHide={() => setShowPrivacy(false)} />
      <TermsModal show={showTerms} onHide={() => setShowTerms(false)} />

      <Form onSubmit={onSubmit} className="contactForm">
        {resStatus ? <Alert variant={resStatus}>{userMess}</Alert> : ""}

        <Form.Group controlId="formBasicUser" className="form-user form-group">
          <Form.Label>Ваше имя*</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ваше имя"
            onChange={nameChangeHandler}
            onKeyPress={onKeyPressHandler}
            value={name}
            required
          />
        </Form.Group>

        <Form.Group controlId="formBasicEmail" className="form-email form-group">
          <Form.Label>Ваш e-mail*</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ваш e-mail"
            onChange={emailChangeHandler}
            onKeyUp={keyUpEmailHandler}
            onKeyPress={onKeyPressHandler}
            value={email}
            required
          />
          <img src={validEmailImg} className="imgCheckEmail" alt="" />
        </Form.Group>

        <Form.Group controlId="formBasicPhone" className="form-phone form-group">
          <Form.Label>Ваш номер телефона*</Form.Label>
          <PhoneInput
            placeholder="Ваш номер телефона"
            className="form-control"
            value={phone}
            defaultCountry={countryCode}
            international={true}
            onKeyUp={keyUpHandler}
            onKeyPress={onKeyPressHandler}
            onChange={setPhone}
            required
          />
          <img src={validPhoneImg} className="imgCheckPhone" alt="" />
        </Form.Group>

        <Form.Group className="form-group">
          <Form.Label>Ваше сообщение*</Form.Label>
          <textarea
            placeholder="Коротко опишите ваш вопрос..."
            className="form-control"
            value={message}
            onKeyUp={keyUpHandler}
            onKeyPress={onKeyPressHandler}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </Form.Group>

        {/* Приписка с ссылками на модалки */}
        <p className="small text-muted mt-2 mb-3">
          Отправляя форму, вы соглашаетесь с нашими{" "}
          <a href="#privacy" onClick={(e) => { e.preventDefault(); setShowPrivacy(true); }}>
            Политикой конфиденциальности
          </a>{" "}
          и{" "}
          <a href="#terms" onClick={(e) => { e.preventDefault(); setShowTerms(true); }}>
            Пользовательским соглашением
          </a>.
        </p>

        <div className="cF-button">
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Отправка..." : "Отправить заявку"}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default LeadForm;
